import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import "../servicesSection/services.scss";
import {
  blackStar,
  CD2,
  CD3,
  CD5,
  CD6,
  CD7,
  IM1,
  IM3,
  IM4,
  IM5,
  Image6,
  Image7,
  SM1,
  SM2,
  SM3,
  SM4,
  SM5,
  yellowStar,
} from "..";
import { FaLongArrowAltRight } from "react-icons/fa";
import { IoIosArrowRoundForward } from "react-icons/io";
import "../../components/servicesSection/services.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  CustomNextArrow,
  CustomPrevArrow,
} from "../../assets/common/CustomArrow/CustomArrow";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Aos from "aos";

const sliderImagesByKey = {
  0: [SM1, SM2, SM3, SM4, SM5],
  1: [CD2, CD3, CD5, CD6, CD7],
  2: [IM3, IM4, IM5, IM1],
  3: [Image6, Image7],
};

const Services = () => {
  const [activeKey, setActiveKey] = useState("0");
  const settings = {
    // dots: activeKey !== null,
    // arrows: activeKey === null,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // margin: 10,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const [hovered, setHovered] = useState(null);
  const allImages = Object.values(sliderImagesByKey).flat();
  // const [currentSliderImages, setCurrentSliderImages] = useState(allImages);
  const [currentSliderImages, setCurrentSliderImages] = useState(
    sliderImagesByKey["0"]
  );

  useEffect(() => {
      Aos.init({ duration: 1000});
    }, []);

  useEffect(() => {
  NativeFancybox.bind("[data-fancybox]");
  return () => NativeFancybox.destroy();
}, []);

  const handleToggle = (key) => {
    // Accordion will send `null` if it's being collapsed
    if (key === activeKey || key === null) {
      setActiveKey(null);
      setCurrentSliderImages(allImages); // Show all images when closed
    } else {
      setActiveKey(key);
      setCurrentSliderImages(sliderImagesByKey[key] || []);
    }
  };

  return (
    <div id="services" className="container">
      <div className="heading-content">
        <p>What We Do</p>
        <p className="description">
          We turn bold ideas into actionable outcomes through smart planning and
          seamless execution.
        </p>
      </div>
      <div className="row service-section">
        {/* Left Column */}
        <div className="col-12 col-lg-4 left-column">
          <Accordion activeKey={activeKey} onSelect={handleToggle}>
            <Accordion.Item eventKey="0" data-aos="fade-down">
              <Accordion.Header className="custom-header">
                <div
                  className={`btn ${activeKey === "0" ? "active" : ""}`}
                  onMouseEnter={() => setHovered("0")}
                  onMouseLeave={() => setHovered(null)}
                >
                  <img
                    src={
                      activeKey === "0" || hovered === "0"
                        ? yellowStar
                        : blackStar
                    }
                    alt="start-Img"
                    className="icon"
                  />
                  <span className="text">Social Media</span>
                  <span
                    className={`arrow ${activeKey === "0" ? "rotate" : ""}`}
                  >
                    <FaLongArrowAltRight />
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body className="custom-body">
                At Brand Craft, we elevate your social media with impactful
                content and real engagement. From scroll-stopping posts to loyal
                community building, we turn followers into customers.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" data-aos="fade-down">
              <Accordion.Header className="custom-header">
                <div
                  className={`btn ${activeKey === "1" ? "active" : ""}`}
                  onMouseEnter={() => setHovered("1")}
                  onMouseLeave={() => setHovered(null)}
                >
                  {/* <img src={yellowStar} alt="start-Img" className="icon" /> */}
                  <img
                    src={
                      activeKey === "1" || hovered === "1"
                        ? yellowStar
                        : blackStar
                    }
                    alt="start-Img"
                    className="icon"
                  />
                  <span className="text">Creative Designing</span>
                  <span
                    className={`arrow ${activeKey === "1" ? "rotate" : ""}`}
                  >
                    <FaLongArrowAltRight />
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body className="custom-body">
                Our designs speak your brand’s language, bold, fresh, and full
                of story. Whether it’s a graphic, video, or visual identity, we
                make sure your brand stands out and stays memorable.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2"  data-aos="fade-down">
              <Accordion.Header className="custom-header">
                <div
                  className={`btn ${activeKey === "2" ? "active" : ""}`}
                  onMouseEnter={() => setHovered("2")}
                  onMouseLeave={() => setHovered(null)}
                >
                  <img
                    src={
                      activeKey === "2" || hovered === "2"
                        ? yellowStar
                        : blackStar
                    }
                    alt="start-Img"
                    className="icon"
                  />
                  <span className="text">Influencer Marketing</span>
                  <span
                    className={`arrow ${activeKey === "2" ? "rotate" : ""}`}
                  >
                    <FaLongArrowAltRight />
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body className="custom-body">
                We match your brand with voices that truly resonate. From
                building authentic partnerships to running seamless campaigns,
                we ensure your message feels real and reaches the right people.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" data-aos="fade-down">
              <Accordion.Header className="custom-header">
                <div
                  className={`btn ${activeKey === "3" ? "active" : ""}`}
                  onMouseEnter={() => setHovered("3")}
                  onMouseLeave={() => setHovered(null)}
                >
                  <img
                    src={
                      activeKey === "3" || hovered === "3"
                        ? yellowStar
                        : blackStar
                    }
                    alt="start-Img"
                    className="icon"
                  />
                  <span className="text">PPC Ads</span>
                  <span
                    className={`arrow ${activeKey === "3" ? "rotate" : ""}`}
                  >
                    <FaLongArrowAltRight />
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body className="custom-body">
                Every click matters. Our paid campaigns are built to convert,
                backed by data, and tailored to your goals. More leads, better
                ROI, and smarter growth, that’s our promise.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

        {/* Middle Column */}
        {/* <div className="col-12 col-lg-5 middle-column">
          <img src={currentImage} alt="Service Preview" className="main-image" />
        </div> */}
        <div className="col-12 col-lg-5 middle-column" data-aos="zoom-in">
          <div className="img-carousel-wrapper">
            <Slider {...settings}>
              {currentSliderImages.map((img, index) => (
                <div className="image-slide" key={index}>
                  <a
                    href={img}
                    data-fancybox="services-gallery"
                    data-caption={`Slide ${index + 1}`}
                  >
                    <img src={img} alt={`slide-${index}`} />
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-12 col-lg-3 right-column">
          <div className="card dark-card" data-aos="flip-up">
            <p>Ever wondered how design magic happens?</p>
            <button className="arrow-btn">
              See how we work{" "}
              <span className="arrow">
                <IoIosArrowRoundForward className="arrow-icon arrow-default" />
                <IoIosArrowRoundForward className="arrow-icon arrow-hover" />
              </span>
            </button>
          </div>
          <div className="card yellow-card" data-aos="flip-down">
            <p>Looking for design experts who can bring your vision to life?</p>
            <button className="arrow-btn dark">
              Meet our expert{" "}
              <span className="arrow">
                <IoIosArrowRoundForward className="arrow-icon arrow-default" />
                <IoIosArrowRoundForward className="arrow-icon arrow-hover" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
